import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { environment } from 'src/environment';

@Component({
  selector: 'app-plan-info',
  templateUrl: `./plan-info.component.html`,
  styleUrls: [`./plan-info.component.scss`],
  standalone: true,
  imports: [NgIf],
})
export class PlanInfoComponent implements OnInit {

  @Input() paymentIntent = '';
  @Input() oldUser = false;
  @Input() showIntent = true;
  @Input() idealBankValidationText;
  freeTrialDays;

  skinName = environment.skinName;
  constructor(private route: ActivatedRoute, public susbscriptionService: SubscriptionService,
    private storageService: StorageService, public configService: ConfigurationService, private planService: PlanService) {
  }

  ngOnInit(): void {
    this.freeTrialDays = +this.storageService.getLocalStore('freeTrialDays');
    const discountCode = this.storageService.getLocalStore('discount_code');
    if (!this.susbscriptionService.planDetails?.plan?.next_billing_date && this.planService.plansLength > 0) {
      const querydata = this.route.snapshot.queryParams;
      const selectedPlan = this.storageService.getSessionStore('selectedPlanData');
      if (selectedPlan.type_of_plan === 'normal_plan') {
        const subscriptionId = this.storageService.getLocalStore('subsId') || selectedPlan?.subscription_id;
        const userPlanData = {
          session_id: querydata['session_id'],
          subscriptionId,
          fingerprint_checked: '',
          stripe_fingerprint: '',
          coupon_code: discountCode ? discountCode: ''
        };
        this.susbscriptionService.invoiceUserPlan(userPlanData).subscribe();
      }
    }
  }

}
